import styled from 'styled-components';

import { OnboardingPage } from '../../../../components/Page';

export const ReplikaGenderStyles = styled(OnboardingPage)`
  padding: 44px 0 34px;

  .local-title {
    margin: 20px auto 0;
  }

  ion-content {
    &::part(scroll) {
      margin-top: 24px;
    }

    .image-container {
      max-width: 230px;
      width: 100%;
      margin: 0 auto;

      img {
        width: 100%;
      }
    }

    .onboarding-gender-options {
      position: absolute;
      bottom: 0;
      left: 0;
      display: flex;
      flex-direction: column;
      width: 100%;
      padding: 0 16px 0;
      gap: 16px;

      &-item {
        background: #ffffff1a;
        backdrop-filter: blur(40px);
        border-radius: 16px;
        width: 100%;
        padding: 14px;

        &.selected {
          background: #7f3ffd7d;
        }
      }
    }
  }
`;
